import { IRetryPolicy, RetryContext } from '@microsoft/signalr';
import { randomDelayMs, spreadDelayMs } from 'src/core/helpers/jitter.helper';

/** An immediate first retry still waits up to this long, so a deploy does not reconnect every tab at once. */
const IMMEDIATE_RETRY_MAX_JITTER_MS = 1000;
/** Shared by SignalR's automatic reconnect and the heartbeat hub's own restart chain. */
export const RETRY_DELAY_SPREAD_RATIO = 0.3;

/** SignalR's fixed delay list with the same attempt count, each delay spread at random. */
export class JitteredRetryPolicy implements IRetryPolicy {
  constructor(
    private readonly baseDelaysMs: readonly number[],
    private readonly randomFraction: () => number,
  ) {}

  nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
    const baseMs = this.baseDelaysMs[retryContext.previousRetryCount];
    if (baseMs === undefined) {
      return null;
    }

    return baseMs === 0
      ? randomDelayMs(this.randomFraction, IMMEDIATE_RETRY_MAX_JITTER_MS)
      : spreadDelayMs(this.randomFraction, baseMs, RETRY_DELAY_SPREAD_RATIO);
  }
}
